import React, {useCallback} from "react";
import "./index.scss";
import {arrayOf, bool, oneOf, shape, string} from "prop-types";
import Text from "features/components/text";
import {__} from "services/i18n";
import {historyObject} from "historyObject";
import {Icon} from "features/components/icon";

export const Breadcrumbs = (props) => {
    const {items, showHomeIcon, type} = props;

    const goToCallback = useCallback((link) => {
        if(!link) return;
        historyObject.push(link);
    }, []);

    if(!items || items.length === 0) {
        return null;
    }
    return <div className={`breadcrumbs ${type || "light"}`}>
        {showHomeIcon && <div onClick={() => goToCallback("/")}><Icon>home</Icon></div>}
        {items.map((i, index) => <div onClick={() => goToCallback(i.link)} className={i.link ? "clickable" : ""} key={i.title}>
            <Text size={14}>{__(i.title)}</Text>
            {index !== items.length - 1 && <span className="separator">/</span>}
        </div>)}
    </div>
};
Breadcrumbs.propTypes = {
    items: arrayOf(shape({
        title: string.isRequired,
        link: string
    })),
    type: oneOf(["dark", "light"]),
    showHomeIcon: bool
};